import { isValidPhoneNumber } from 'libphonenumber-js';

/**
 * Check if text is valid phone number or email
 */
export function isValidPhoneNumberOrEmail(text, countryCode = '') {
  const emailRegex = /^\S+@\S+\.\S+$/;
  const isValidEmail = emailRegex.test(text);
  const isValidPhone = isValidPhoneNumber(`${countryCode}${text}`);

  return isValidEmail || isValidPhone;
}

/**
 * Check if error message type as string
 */
export function checkErrorTypeString(message, fallback = 'Error') {
  if (message && typeof message === 'string') {
    return message;
  }

  return fallback;
}

/**
 * Check if entered password is valid
 */
export function isValidPassword(password) {
  if (!password) {
    return false;
  }

  const lengthCheck = password.length >= 8;
  const numberCheck = /\d/.test(password);
  const specialCharCheck = /[^A-Za-z0-9]/.test(password);

  if (lengthCheck && numberCheck && specialCharCheck) {
    return true;
  }

  return false;
}



export function isChristmasSeason() {
  const date = new Date();
  const month = date.getMonth(); // 0 = January, 11 = December
  const day = date.getDate();
  if (
    (month === 11 && day >= 20) || // December 20th or later
    (month === 0 && day <= 7)      // January 1st to 7th
  ) {
    return true;
  }
  return false;
}


export function capitalizeFirstLetter(string) {
  if (typeof string !== 'string') {
    return '';
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Check if company name contains only alphanumeric characters, spaces, and hyphens
 */
export function isValidCompanyName(name) {
  const hasOnlyAllowedCharacters = /^[A-Za-z0-9 -]+$/.test(name);
  const hasAtLeastOneAlphanumericCharacter = /[A-Za-z0-9]/.test(name);
  const hasNoLeadingOrTrailingSpaces = name.trim() === name;

  return (
    hasOnlyAllowedCharacters &&
    hasAtLeastOneAlphanumericCharacter &&
    hasNoLeadingOrTrailingSpaces
  );
}